/**
 * iter259 — Menu d'assistance Claude pour la rédaction d'un e-mail.
 * Utilisé à la fois dans la réponse à un fil et dans « Nouveau message ».
 */
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Wand2, ChevronDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function MailAssistMenu({ text, onResult, threadKey, testId = "mail-rewrite" }) {
  const [busy, setBusy] = useState(false);

  const run = async (mode, extra = {}) => {
    if (!String(text || "").trim()) {
      toast.error("Écrivez d'abord un texte à retravailler");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/mail/assist", { mode, text, thread_key: threadKey, ...extra });
      onResult(data?.text || text);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Assistant IA indisponible");
    } finally { setBusy(false); }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={busy} data-testid={`${testId}-btn`}>
          {busy ? <Loader2 className="w-4 h-4 sm:mr-1.5 animate-spin" /> : <Wand2 className="w-4 h-4 sm:mr-1.5" />}
          <span className="hidden sm:inline">Reformuler</span>
          <ChevronDown className="w-3 h-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-52">
        <DropdownMenuItem onClick={() => run("reformuler", { ton: "court" })} data-testid={`${testId}-court`}>
          Plus court
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => run("reformuler", { ton: "formel" })} data-testid={`${testId}-formel`}>
          Plus formel
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => run("reformuler", { ton: "chaleureux" })} data-testid={`${testId}-chaleureux`}>
          Plus chaleureux
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => run("traduire", { langue: "allemand" })} data-testid={`${testId}-de`}>
          Traduire en allemand
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => run("traduire", { langue: "anglais" })} data-testid={`${testId}-en`}>
          Traduire en anglais
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => run("traduire", { langue: "français" })} data-testid={`${testId}-fr`}>
          Traduire en français
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
